import "../../style/scss/App.scss";
import ListIconButton from "../Controls/ListIconButton";
import { FaTrashAlt } from "react-icons/fa";

const ROLE_LABELS = {
  20: "Admin",
  30: "HR",
  50: "Recruiter",
};

function roleLabels(roles) {
  return (roles || [])
    .map((id) => ROLE_LABELS[Number(id)] || `Role ${id}`)
    .filter(Boolean)
    .join(", ");
}

export default function EmployerAdminListItem({ admin, onRemove, removeBusy }) {
  if (!admin) return null;

  const personId = admin.PersonID ?? admin.personID ?? admin.personId;
  const firstName = admin.FirstName ?? admin.firstName ?? "";
  const lastName = admin.LastName ?? admin.lastName ?? "";
  const email = admin.Email ?? admin.email ?? "";
  const title = admin.Title ?? admin.title ?? "";
  const roles = admin.Roles ?? admin.roles ?? [];
  const name = `${firstName} ${lastName}`.trim() || "Unknown";
  const rolesText = roleLabels(roles);

  return (
    <li className="listItem employer-admin-row" data-testid={`employer-admin-${personId}`}>
      <div className="Job mobilePanel">
        <span className="title">{name}</span>
        {title ? <span className="byline">{title}</span> : null}
        {email ? <span className="byline">{email}</span> : null}
        {rolesText ? <span className="rightText">{rolesText}</span> : null}
      </div>
      {onRemove ? (
        <ListIconButton
          aria-label={`Remove ${name}`}
          title="Remove administrator"
          data-testid={`employer-admin-remove-${personId}`}
          disabled={!!removeBusy}
          onClick={() => onRemove(personId, name)}
        >
          <FaTrashAlt aria-hidden />
        </ListIconButton>
      ) : null}
    </li>
  );
}
